import {FaEye, FaUpload} from "react-icons/fa";
import {getUrl} from "../../../constants/urls";

export const orgsListURL = getUrl("orgs");

export const ACTIONS_LIST = [
  {label: "View", icon: FaEye, perms: ["change_organization"]},
  {label: "Push_Templates", icon: FaUpload, perms: ["can_sync"]},
];

export const PERMS_FOR_ACTIONS = ["change_organization", "can_sync"];

export const LIST_HEADERS = ["name", "slug", "total_system", "is_active"];

const organizationColumns = {
  Name: "name",
  Slug: "slug",
};

export const getColumnValue = (label) => {
  return organizationColumns[`${label}`];
};
